import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";

export default function Login() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("teacher@vrclass.edu");
  const [password, setPassword] = useState("teach123");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      nav("/dashboard");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative hero-noise">
        <img
          src="https://images.unsplash.com/photo-1771765764892-91f2ed4ddbf4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxrMTIlMjBzdHVkZW50cyUyMHZpcnR1YWwlMjByZWFsaXR5JTIwY2xhc3Nyb29tJTIwbGVhcm5pbmd8ZW58MHx8fHwxNzg3NDU5ODI5fDA&ixlib=rb-4.1.0&q=85"
          alt="VR classroom"
          className="absolute inset-0 w-full h-full object-cover mix-blend-luminosity opacity-90"
        />
        <div className="absolute inset-0 bg-gradient-to-tr from-primary/70 to-accent/40" />
        <div className="absolute bottom-12 left-12 right-12 text-white">
          <h2 className="text-3xl font-display font-bold leading-tight">Build tomorrow's lesson tonight.</h2>
          <p className="mt-3 text-white/85 max-w-md">Standards-aligned immersive VR for every K-12 classroom.</p>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <Link to="/" className="inline-flex items-center mb-10">
            <img src="/logo-light.png" alt="VividVR" className="h-9 w-auto" />
          </Link>
          <h1 className="text-3xl font-display font-bold tracking-tight">Sign in</h1>
          <p className="text-muted-foreground mt-2">Welcome back to your VR classroom.</p>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-11" required />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 h-11" required />
            </div>
            <Button type="submit" data-testid="login-submit-btn" disabled={loading} className="w-full h-11 rounded-full text-base">
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Sign in"}
            </Button>
          </form>

          <p className="text-sm text-muted-foreground mt-6 text-center">
            No account?{" "}
            <Link to="/register" data-testid="login-register-link" className="text-primary font-semibold hover:underline">
              Create one
            </Link>
          </p>
          <div className="mt-6 rounded-xl bg-secondary p-3 text-xs text-muted-foreground text-center">
            Demo: teacher@vrclass.edu · teach123
          </div>
        </div>
      </div>
    </div>
  );
}
